<template>
    <v-container fluid id="app-layout-main-page">
        <v-row no-gutters>
            <v-col cols="12">

                <v-row no-gutters>
                    <v-col cols="12">
                        <application-header></application-header>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col
                            cols="12"
                            xl="6"
                            lg="8"
                            md="10"
                            sm="12"
                            xs="12"
                            offset-md="1"
                            offset-lg="2"
                            offset-xl="3"
                    >

                        <search-window></search-window>

                        <map-open-layers></map-open-layers>

                        <search-result v-if="showResult"></search-result>
                        <protection-status v-if="showProtection"
                                           style="width: 99%; padding-top: 50px"></protection-status>
                        <species-overview v-if="showStatistics"></species-overview>
                        <image-gallery v-if="showStatistics"></image-gallery>

                    </v-col>
                </v-row>

                <application-footer></application-footer>

                <app-popup
                        :title="$t('main.errorMessage')"
                        :text="$t('main.errorText')"
                        :showPopup.sync="showDialog"
                        @cancel="showDialog=false"
                />

                <app-popup
                        :title="$t('main.noObservationsMessage')"
                        :text="$t('main.noObservationsText')"
                        :showPopup.sync="showDialogNoObservations"
                        @cancel="showDialogNoObservations=false"
                />
            </v-col>
        </v-row>


    </v-container>
</template>

<script>
    import ApplicationHeader from './AppHeader'
    import ApplicationFooter from './AppFooter'
    import AppPopup from '../AppComponents/AppPopupDialog'
    import ImageGallery from '../ImageGallery/ImageGallery'
    import MapOpenLayers from '../Map/MapOpenLayers/MapOpenLayers'
    import ProtectionStatus from '../SpeciesOverview/ProtectionStatus'
    import SearchWindow from '../SearchWindow/SearchWindow'
    import SearchResult from '../SearchWindow/SearchResult'
    import SpeciesOverview from '../SpeciesOverview/SpeciesOverview'

    import axios from 'axios'
    import {speciesUrl} from '../../data/app-data'
    import {API_ERROR_MESSAGE, CONFIG_ERROR_MESSAGE, URL_ERROR_MESSAGE} from '../../data/constants'
    import i18n from '../../plugins/i18n'

    export default {
        name: 'MainPage',
        components: {
            ApplicationHeader,
            SearchWindow,
            SearchResult,
            MapOpenLayers,
            ProtectionStatus,
            SpeciesOverview,
            ImageGallery,
            ApplicationFooter,
            AppPopup
        },
        data() {
            return {
                showResult: false,
                showStatistics: false,
                showProtection: false,
                showDialog: false,
                showDialogNoObservations: false,
            }
        },
        computed: {
            taxonId() {
                return this.$store.state.taxonId
            },
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            isLichenApp() {
                return this.$store.getters.isLichenApp
            },
            timeRange() {
                return [this.$store.state.yearRange.min, this.$store.state.yearRange.max]
            },
            protectionAPI() {
                return this.isFungusApp ? speciesUrl.protectionFungus : speciesUrl.protectionLichen
            },
            lang() {
                return i18n.locale
            }
        },
        watch: {
            taxonId() {
                this.resetProtectionStatisticsPanels()
                this.getCountsPerID()
            },
            timeRange() {
                this.resetProtectionStatisticsPanels()
                this.getCountsPerID()
            },
            isFungusApp(){
                // make sure that either FUNGUS or LICHEN config is selected before running the app
                this.checkCorrectApplicationConfig()
            },
            isLichenApp(){
                // make sure that either FUNGUS or LICHEN config is selected before running the app
                this.checkCorrectApplicationConfig()
            },
            lang() {
                this.resetProtectionStatisticsPanels()
                this.getCountsPerID()
            }
        },
        methods: {

            getCountsPerID() {
                if (this.taxonId !== null) {
                    this.showResult = true

                    axios.get(this.protectionAPI + this.taxonId).then((result) => {
                        let res = result.data
                        this.$store.commit('setTotalListEntries', res.length)
                    }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                        this.$store.commit('setTotalListEntries', 0)
                    })

                    axios.get(speciesUrl.observationCount + this.taxonId)
                        .then((result) => {
                            this.$store.commit('setTotalObservations', result.data)
                            this.toggleProtectionStatisticsPanels()
                        }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                        this.$store.commit('setTotalObservations', 0)
                    })

                    axios.get(speciesUrl.observationSelected + this.taxonId + '?startyear=' + this.$store.state.yearRange.min + '&endyear=' + this.$store.state.yearRange.max)
                        .then((result) => {
                            this.$store.commit('setTotalObservationsSelected', result.data[0].count)
                        }).catch((error) => {
                        console.log(API_ERROR_MESSAGE, error)
                        this.$store.commit('setTotalObservationsSelected', 0)
                    })


                } else {
                    this.resetProtectionStatisticsPanels()
                }
            },
            getName(nameResult) {
                let taxonAutor = nameResult.taxonAutor === null ? '' : nameResult.taxonAutor
                let fullName = nameResult.taxonName + ' ' + taxonAutor
                return fullName.trim()
            },

            resetProtectionStatisticsPanels() {
                // disable component for dynamic reloading of chart data
                this.showStatistics = false
                this.showResult = false
                this.showProtection = false
            },

            toggleProtectionStatisticsPanels() {
                // only show statistics panels if at least 1 observation has been found
                // and display red list protection status if there are no observations
                this.showStatistics = this.$store.state.totalObservations !== 0
                this.showProtection = this.$store.state.totalObservations === 0 && this.$store.state.totalListEntries !== 0
                this.showDialogNoObservations = this.$store.state.totalObservations === 0
            },

            checkCorrectApplicationConfig() {
                if (this.isFungusApp) {
                    console.log('Selected run config: ', 'FUNGUS')
                } else if (this.isLichenApp) {
                    console.log('Selected run config: ', 'LICHEN')
                } else {
                    console.log(CONFIG_ERROR_MESSAGE)
                }
            }
        },
        beforeCreate() {
            this.$store.dispatch('init')

            // parse url query parameters and commit values to store
            const queryString = window.location.search.substring(1)
            if (queryString) {
                const urlParams = new URLSearchParams(queryString)
                let taxonId = urlParams.get('taxon')
                let start = Number.isNaN(parseInt(urlParams.get('start'))) ? 1990 : parseInt(urlParams.get('start'))
                let end = Number.isNaN(parseInt(urlParams.get('end'))) ? new Date().getFullYear() : parseInt(urlParams.get('end'))

                // parse locale from browser session using the format en-US
                // language parameter can be set using iso-codes, eg. search?taxon=547&start=1991&end=2020&lang=en
                // allowed codes: {it, en, de, fr}
                let lang = urlParams.get('lang') ? urlParams.get('lang') : i18n.locale.split('-')[0]
                this.$store.commit('setLang', lang)

                if (taxonId !== null) {
                    axios.get(speciesUrl.speciesNamesByTaxon + taxonId)
                        .then((result) => {
                            const acceptedName = this.getName(result.data.currentNames[0])
                            this.$store.commit('setTaxonId', taxonId)
                            this.$store.commit('setYearMin', start)
                            this.$store.commit('setYearMax', end)
                            this.$store.commit('setTaxonName', acceptedName)
                        })
                        .catch((error) => {
                            console.log(URL_ERROR_MESSAGE, queryString, error)
                            // this.showDialog = true // deactivated to avoid error message if page is reloaded
                        })
                } else {
                    this.$store.commit('setTaxonId', null)
                    this.$store.commit('setYearMin', start)
                    this.$store.commit('setYearMax', end)
                    this.$store.commit('setTaxonName', '')
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../global';

    #app-layout-main-page {
        height: 100%;
        background-color: $app-light-background;
        padding: 0;
    }


</style>
